<app-dialog
        [dialogWithInput]="dialog">
    <app-create-update-default #createUpdateDefaultComponent
                               [formGroup]="formGroup"
                               [id]="id"
                               [buildPayload]="buildPayload"
                               (entitySaved)="entitySaved($event)"
                               (entityLoaded)="entityLoaded($event)"
                               [findOneService]="findByIdService"
                               [dontGoBakOnSaveSuccess]="true"
                               [service]="saveService"
                               [hideSaveButton]="true">
        <ng-template template-content>
            <app-card-v2>
                <div class="row">
                    <app-form-field label="Date" [required]="true">
                        <app-date-picker [parentFormGroup]="formGroup" parentFormControlName="date"></app-date-picker>
                    </app-form-field>
                </div>
                <div class="row">
                    <app-form-field label="Taille" size="12" sizeLg="3" sizeXl="3">
                        <app-number-input [parentFormGroup]="formGroup" parentFormControlName="height" unit="cm" [decimalDigits]="1"></app-number-input>
                    </app-form-field>
                    <app-form-field label="Poids" size="12" sizeLg="3" sizeXl="3">
                        <app-number-input [parentFormGroup]="formGroup" parentFormControlName="weight" unit="kg" [decimalDigits]="1"></app-number-input>
                    </app-form-field>
                    <app-form-field label="IMC" size="12" sizeLg="3" sizeXl="3">
                        <app-bmi-summary-field [height]="formGroup.get('height').value" [weight]="formGroup.get('weight').value"></app-bmi-summary-field>
                    </app-form-field>
                    <app-form-field label="Pointure" size="12" sizeLg="3" sizeXl="3">
                        <app-number-input [parentFormGroup]="formGroup" [decimalDigits]="2" parentFormControlName="shoeSize"
                                          unit="EU"></app-number-input>
                    </app-form-field>
                </div>
                <div class="row">
                    <app-form-field label="Commentaire" size="12">
                        <app-rich-text-editor [audioTranscriptionConfig]="audioTranscription" [parentFormGroup]="formGroup" parentFormControlName="comment"></app-rich-text-editor>
                    </app-form-field>
                </div>
            </app-card-v2>
        </ng-template>
    </app-create-update-default>

    <ng-container dialog-actions>
        <app-loading [loading]="createUpdateDefaultComponent.saveLoading" [showText]="false"></app-loading>
        <app-button (click)="executeSave()" [disabled]="!formGroup.valid" fill="solid" color="primary"
                    iconName="check" label="Enregistrer" *ngIf="!createUpdateDefaultComponent.saveLoading &&
                !createUpdateDefaultComponent.loading && !createUpdateDefaultComponent.findOneError"></app-button>
    </ng-container>
</app-dialog>
